import { isAuditOperation } from "../valueObjects/auditOperations";
import { assertString } from "../utils/assertions";
import { createUuid } from "../utils/id";
import { nowIso } from "../utils/timestamps";

export const createAuditEntry = ({
  id = createUuid(),
  entityType,
  entityId,
  operation,
  actorId,
  occurredAt = nowIso(),
  revision,
  summary,
  payload,
}) => {
  assertString(id, "auditEntry.id");
  assertString(entityType, "auditEntry.entityType");
  assertString(entityId, "auditEntry.entityId");

  if (!isAuditOperation(operation)) {
    throw new Error("auditEntry.operation must be a valid audit operation");
  }

  return {
    id,
    entityType,
    entityId,
    operation,
    actorId,
    occurredAt,
    revision,
    summary,
    payload,
    schemaVersion: 1,
  };
};
